import { collection, getDocs, query, orderBy, doc, updateDoc, setDoc, deleteDoc, arrayUnion, arrayRemove, Timestamp } from 'firebase/firestore';
import { db } from '../config/firebase/firebaseConfig';
import { ResourceModel, ResourceCollection } from '../types/resource';

const COLLECTIONS = {
  resources: 'resources',
};

export class ResourcesService {
  static async loadResources(): Promise<ResourceCollection[]> {
    try {
      const q = query(
        collection(db, COLLECTIONS.resources),
        orderBy('order')
      );

      const querySnapshot = await getDocs(q);
      const resourceCollections: ResourceCollection[] = [];

      for (const docSnapshot of querySnapshot.docs) {
        const data = docSnapshot.data();
        const resourcesArray = data.resourceList || [];

        const resources: ResourceModel[] = resourcesArray.map((resourceData: any) => ({
          title: resourceData.title,
          description: resourceData.description,
          url: resourceData.url,
          createdAt: resourceData.createdAt?.toDate() || new Date(),
        }));

        resourceCollections.push({
          id: docSnapshot.id,
          category: data.category,
          order: data.order,
          resources: resources,
        });
      }

      return resourceCollections;
    } catch (error) {
      console.error('Error loading resources:', error);
      throw new Error('Failed to load resources');
    }
  }

  static async saveResourceToCollection(resource: ResourceModel, collectionId: string): Promise<void> {
    try {
      const collectionRef = doc(db, COLLECTIONS.resources, collectionId);

      const resourceData = {
        title: resource.title,
        description: resource.description,
        url: resource.url,
        createdAt: Timestamp.fromDate(resource.createdAt),
      };

      await updateDoc(collectionRef, {
        resourceList: arrayUnion(resourceData),
      });
    } catch (error) {
      console.error('Error saving resource:', error);
      throw new Error('Failed to save resource');
    }
  }

  static async addCollection(collection: ResourceCollection): Promise<void> {
    try {
      const collectionRef = doc(db, COLLECTIONS.resources, collection.id);

      await setDoc(collectionRef, {
        id: collection.id,
        category: collection.category,
        order: collection.order,
        resourceList: [],
      });
    } catch (error) {
      console.error('Error adding collection:', error);
      throw new Error('Failed to add collection');
    }
  }

  static async deleteResourceFromCollection(resource: ResourceModel, collectionId: string): Promise<void> {
    try {
      const collectionRef = doc(db, COLLECTIONS.resources, collectionId);

      const resourceData = {
        title: resource.title,
        description: resource.description,
        url: resource.url,
        createdAt: Timestamp.fromDate(resource.createdAt),
      };

      await updateDoc(collectionRef, {
        resourceList: arrayRemove(resourceData),
      });
    } catch (error) {
      console.error('Error deleting resource:', error);
      throw new Error('Failed to delete resource');
    }
  }

  static async deleteCollection(collectionId: string): Promise<void> {
    try {
      const collectionRef = doc(db, COLLECTIONS.resources, collectionId);
      await deleteDoc(collectionRef);
    } catch (error) {
      console.error('Error deleting collection:', error);
      throw new Error('Failed to delete collection');
    }
  }
}